module.exports = __webpack_public_path__ + "img/ccfdec5a0f9517dc659965a99ca164d0.02b65a10.jpg";